import { AsyncPipe, TitleCasePipe } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core'
import { RouterLink } from '@angular/router'
import { CourtSystemWithMetadata } from '@ftr/contracts/api/court-system'
import { ProductionStatus } from '@ftr/contracts/type/court/ProductionStatus'
import { Uuid } from '@ftr/contracts/type/shared'
import {
  DestroySubscribers,
  IconComponent,
  TooltipDisplay,
  TooltipModule,
  TooltipPosition,
  unwrapData,
} from '@ftr/foundation'
import { DropdownMenuComponent, DropdownMenuItemsComponent, StaticMenuItem } from '@ftr/menus'
import { AppPaths } from '@ftr/routing-paths'
import { COURT_SYSTEM_NAV_ITEMS, SideNavDisplayMode } from '@ftr/ui-core'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { Observable, map } from 'rxjs'

@Component({
  selector: 'ftr-court-system-dropdown',
  templateUrl: './court-system-dropdown.component.html',
  styleUrls: ['./court-system-dropdown.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    IconComponent,
    AsyncPipe,
    TooltipModule,
    DropdownMenuComponent,
    DropdownMenuItemsComponent,
    TitleCasePipe,
    RouterLink,
  ],
})
export class CourtSystemDropdownComponent extends DestroySubscribers implements OnInit {
  @Input() currentCourtSystemId: Uuid
  @Input() collapsed: boolean
  @Input() displayMode: SideNavDisplayMode = 'DEFAULT'
  @Output() dropdownOpened = new EventEmitter<CourtSystemWithMetadata>()

  courtSystem$: Observable<CourtSystemWithMetadata>

  protected courtSystemMenuItems: StaticMenuItem[]
  @ViewChild(DropdownMenuComponent) protected dropdown: DropdownMenuComponent

  protected readonly productionStatus = ProductionStatus
  protected readonly tooltipDisplay = TooltipDisplay
  protected readonly tooltipPosition = TooltipPosition
  protected readonly appPaths = AppPaths

  constructor(private readonly store: Store) {
    super()
  }

  ngOnInit(): void {
    this.fetchCourtSystem()
    this.setCourtSystemMenuItems()
  }

  toggle(): void {
    this.dropdown.toggle()
  }

  private fetchCourtSystem(): void {
    this.courtSystem$ = this.store.select(UserState.courtSystems).pipe(
      unwrapData(),
      map(courtSytem => courtSytem.filter(c => c.id === this.currentCourtSystemId)?.at(0)),
    ) as Observable<CourtSystemWithMetadata>
  }

  private setCourtSystemMenuItems(): void {
    this.courtSystemMenuItems = COURT_SYSTEM_NAV_ITEMS
  }
}
